import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { EditIcon, XIcon } from "@src/assets/icons"
import { trans } from "@utils"

import { getOperatorByValue } from "../input-group-builder/Utils"

const Tags = (props) => {
  const { value, options, isLoading, onEdit, onClear } = props
  if (isLoading) return null
  return (
    _.size(value) > 0 && (
      <div className="d-flex flex-wrap mb-50" style={{ gap: "0.5rem" }}>
        {_.map(value, (v, k) => {
          const option = _.get(options, k)
          const operator = getOperatorByValue(option.type, v)
          const value = !_.isUndefined(v.options) && _.size(v.options) > 0
            ? _.map(v.options, (o) => o.label).join(", ") 
            : _.isArray(v.value) ? _.join(v.value, ", ") : v.value
          return (
            <div key={k} className="d-flex align-items-center bg-light border border-1 border-radius-5 cursor-pointer" style={{ minWidth: 0 }}>
              <div className="d-flex align-items-center px-50" style={{ minWidth: 0 }} onClick={() => onEdit({ option, value: v })}>
                <FontAwesomeIcon size="sm" icon={EditIcon} />
                <div className="text-truncate">
                  <span className="text-nowrap ml-50">{option.label}</span>
                  <span className="text-nowrap font-weight-bolder ml-50">{trans(operator.label)}</span>
                  {value !== "null" && <span className="text-nowrap ml-50">{value}</span>}
                </div>
              </div>
              <div className="advanced-filter-tag-clear border-left border-1 px-50" onClick={() => onClear(k, option)}>
                <FontAwesomeIcon size="sm" icon={XIcon} />
              </div>
            </div>
          )
        })}
      </div>
    )
  )
}

export default Tags
